<template>
  <span>
    <widget-common-props :field="field" @changeProp="changeProp" />

    <b-form-group label-cols="3" label="Placeholder">
      <b-form-input
        @change="changeProp"
        label="Placeholder"
        v-model="field.params.placeholder"
      />
    </b-form-group>
    <b-form-group label-cols="3" label="Tooltip">
      <b-form-input
        @change="changeProp"
        label="Tooltip"
        v-model="field.params.tooltip"
      />
    </b-form-group>

    <b-form-group label-cols="3" label="Layout">
      <b-form-select @change="changeProp" v-model="field.params.layout">
        <option value="list_group">List Group</option>
      </b-form-select>
    </b-form-group>

    <b-form-group
      label-cols="3"
      label=""
      v-if="field.params.layout == 'buttons' || field.params.layout == 'radios'"
    >
      <b-form-checkbox @input="changeProp" v-model="field.params.stacked"
        >Stacked</b-form-checkbox
      >
    </b-form-group>

    <b-card no-body>
      <b-tabs card>
        <b-tab title="Edit Table" active>
          <div v-if="multiple_values != ''" class="alert alert-warning">
        Duplicate value(s) detected {{ multiple_values }}
      </div>

          <table>
            <thead>
              <th>Index</th>
              <th>
                <b-form-select
                  :options="CODE_TYPE_LIST"
                  @change="changeProp"
                  v-model="field.params.valueType"
                />
              </th>
              <th>Description</th>
              <th><b-button @click="addOption">Add</b-button></th>
            </thead>

            <tr v-for="(item, item_idx) in field.params.options">
              <td>{{ item_idx + 1 }}</td>
              <td>
                <b-form-input
                  :type="field.params.valueType"
                  @change="changeProp"
                  v-model="field.params.options[item_idx].value"
                ></b-form-input>
              </td>
              <td>
                <b-form-input
                  @change="changeProp"
                  v-model="field.params.options[item_idx].text"
                ></b-form-input>
              </td>
              <td>
                <o-list-actions
                  :list="field.params.options"
                  :index="item_idx"
                ></o-list-actions>
              </td>
            </tr>
          </table>
        </b-tab>
        <b-tab title="Text Lines">
          <b-form-textarea
            :value="optionsAsLines"
            @change="updateLines"
            rows="6"
          >
          </b-form-textarea>
        </b-tab>
      </b-tabs>

      <div v-if="multiple_values != ''" class="alert alert-warning">
        Duplicate value(s) detected {{ multiple_values }}
      </div>
    </b-card>

    <!-- Default Settings -->
    <b-form-group label-cols="3" label="">
      <b-form-checkbox @input="changeProp" v-model="field.default_option"
        >Has Default</b-form-checkbox
      >
    </b-form-group>

    <b-form-group
      label-cols="3"
      label="Default Value"
      v-if="field.default_option"
    >
      <b-form-select
        :options="field.params.options"
        :value="field.default_value"
        @change="changeProp"
        @input="setDefault"
      >
      </b-form-select>
    </b-form-group>
  </span>
</template>

<script>
import WidgetCommonProps from "../WidgetCommonProps.vue";
import OListActions from "../../../vue-ocom/components/table/OListActions.vue";
import WidgetPropMixin from "../WidgetPropMixin.js";
import { forEach } from "lodash";

export default {
  name: "MultiSelectProps",
  components: { OListActions, WidgetCommonProps },
  mixins: [WidgetPropMixin],
  data: function () {
    var CODE_TYPE_LIST = [
      { value: "text", text: "Code" },
      { value: "number", text: "ID" },
    ];

    return {
      CODE_TYPE_LIST: CODE_TYPE_LIST,
    };
  },
  methods: {
    addOption: function () {
      if (!("options" in this.field.params)) {
        this.$set(this.field.params, "options", []);
      }

      var options = this.field.params.options;

      var value = null;

      if (this.field.params.valueType != "text") {
        value = (_.maxBy(options, "value") || { value: 0 }).value + 1;
      }

      options.push({ value: value, text: "" });

      console.log(
        `[${new Date().toISOString()}] MultiSelectProps @change event:`,
        {
          component: "MultiSelectProps",
          method: "addOption",
          fieldCode: this.field.code,
          optionsCount: options.length,
          field: this.field,
        }
      );
      this.$emit("change", this.field);
    },
    updateLines: function (text) {
      var lines = text.split("\n");

      var options = this.field.params.options || [];

      _.each(lines, function (line, index) {
        var value = null;
        var text = line;

        if (line.includes("=")) {
          var row = line.split("=");

          value = row[0];
          text = row[1];
          try {
            value = _.toNumber(value); // try to conver to a number
          } catch (e) {
            // Ignore
          }
        }
        if (index > options.length - 1) {
          if (value == null) {
            value = (_.maxBy(options, "value") || { value: 0 }).value + 1;
          }

          options.push({ value: value, text: text });
        } else {
          options[index].value = value;
          options[index].text = text;
        }
      });

      this.$set(this.field.params, "options", options);
      this.changeProp();
    },
    setDefault(value) {
      this.$set(this.field, "default_value", value);
    },
  },
  computed: {
    optionsAsLines() {
      if (!("options" in this.field.params)) {
        return "";
      }

      var result = _.map(this.field.params.options, function (line) {
        return line.value + "=" + line.text;
      }).join("\n");

      return result;
    },
    multiple_values() {
      var valuesUsed = {};
      var result = "";

      forEach(this.field.params.options, function (o) {
        if (o.value in valuesUsed) {
          result = result + " " + o.value;
        }
        valuesUsed[o.value] = true;
      });

      return result;
    }
  },
};
</script>
